import { render, staticRenderFns } from "./RedeemFlow.vue?vue&type=template&id=c3464c82&scoped=true"
import script from "./RedeemFlow.vue?vue&type=script&lang=js"
export * from "./RedeemFlow.vue?vue&type=script&lang=js"
import style0 from "./RedeemFlow.vue?vue&type=style&index=0&id=c3464c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3464c82",
  null
  
)

export default component.exports